import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const getJobTitleSuggestions = async (
  query: string,
  text: string,
  geoUrns: string[],
  liAtCookie: string,
  sessionCookie: string
) => {
  try {
    const response = await API_V1.post('/linkedin/lookups/job-titles', {
      query,
      title: query,
      text,
      geoUrns,
      liAtCookie,
      sessionCookie,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting job title suggestions!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
